import React from 'react';
import { Label, Input, FormFeedback } from 'reactstrap';
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import api from "../../../api";

const PermisoFormSections = ({
    disabled = false,
    padre,
    autoFocusFirstField = false,
}) => (
    <div className="ui-section-stack">
        <section className="ui-section-block">
            <p className="ui-section-label">Datos del permiso</p>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Nombre</Label>
                    <Input disabled={disabled} type="text" name="nombre" autoFocus={autoFocusFirstField} data-auto-focus={autoFocusFirstField ? "true" : null}></Input>
                    <FormFeedback className="col-12"></FormFeedback>
                </div>
            </div>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Descripcion</Label>
                    <Input disabled={disabled} type="textarea" name="descripcion" rows="3"/>
                    <FormFeedback className="col-12"></FormFeedback>
                </div>
            </div>
        </section>

        <section className="ui-section-block">
            <p className="ui-section-label">Pertenencia</p>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Padre</Label>
                    <ParadigmaAsyncSeeker
                        disabled={disabled}
                        fieldName={"padre_id"}
                        url={api.usuarios.permisos.select}
                        value={padre} />
                    <FormFeedback className="col-12"></FormFeedback>
                </div>
            </div>
        </section>
    </div>
);

export default PermisoFormSections;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Permisos/PermisoFormSections.js